import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
  Checkbox,
  ListItemText
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import BuildIcon from '@material-ui/icons/Build';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 200,
    maxWidth: 400,
    backgroundColor: '#fff',
    borderRadius: theme.spacing(0.5),
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main
      }
    }
  },
  selectInput: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5)
  },
  chip: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.dark,
    fontWeight: 500
  },
  allChip: {
    backgroundColor: theme.palette.secondary.main,
    color: '#fff'
  },
  menuItem: {
    '&.Mui-selected': {
      backgroundColor: `${theme.palette.primary.light}20`,
      '&:hover': {
        backgroundColor: `${theme.palette.primary.light}30`
      }
    }
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main
  }
}));

const DivisionFilter = ({ divisions = [], selectedDivisions = ['all'], onChange }) => {
  const classes = useStyles();

  const handleChange = (event) => {
    const value = event.target.value;
    
    // Handle "all" selection
    if (value.includes('all')) {
      if (selectedDivisions.includes('all')) {
        // If "all" was already selected and user clicks something else, remove "all"
        onChange(value.filter(v => v !== 'all'));
      } else {
        // If user selects "all", clear other selections
        onChange(['all']);
      }
    } else {
      onChange(value);
    }
  };

  const renderValue = (selected) => {
    if (selected.includes('all')) {
      return (
        <Box className={classes.chips}>
          <Chip
            size="small"
            label="All Divisions"
            className={`${classes.chip} ${classes.allChip}`}
            icon={<AllInclusiveIcon />}
          />
        </Box>
      );
    }

    return (
      <Box className={classes.chips}>
        {selected.map((value) => (
          <Chip
            key={value}
            size="small"
            label={value}
            className={classes.chip}
          />
        ))}
      </Box>
    );
  };

  const isAllSelected = selectedDivisions.includes('all');

  return (
    <FormControl 
      variant="outlined" 
      size="small"
      className={classes.formControl}
    >
      <InputLabel id="division-filter-label">
        <Box className={classes.selectInput}>
          <BuildIcon fontSize="small" />
          Filter by Division
        </Box>
      </InputLabel>
      <Select
        labelId="division-filter-label"
        id="division-filter"
        multiple
        value={selectedDivisions}
        onChange={handleChange}
        renderValue={renderValue}
        label="Filter by Division"
      >
        <MenuItem value="all" className={classes.menuItem}>
          <Checkbox checked={isAllSelected} color="primary" />
          <ListItemText primary="All Divisions" />
        </MenuItem>
        {divisions.map((division) => (
          <MenuItem 
            key={division} 
            value={division}
            className={classes.menuItem}
            disabled={isAllSelected}
          >
            <Checkbox 
              checked={selectedDivisions.includes(division)} 
              color="primary"
              disabled={isAllSelected}
            />
            <ListItemText primary={division} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DivisionFilter;